import { Controller } from "stimulus";
import { useClickOutside, useDispatch, useHotkeys } from 'stimulus-use';

export default class extends Controller {
  static targets = ["box"];

  connect() {
    useClickOutside(this);
    useDispatch(this);

    // https://www.w3.org/TR/wai-aria-practices-1.2/#dialog_modal
    // https://headlessui.dev/react/dialog#keyboard-interaction
    useHotkeys(this, {
      'Tab': [this.onNextFocusItem],
      'Shift+Tab': [this.onPreviousFocusItem],
      'Escape': [this.onEscape]
    });
  }

  get focusableElementsAndIndex() {
    const elements = Array.from(this.boxTarget.querySelectorAll('button, a[href]'));

    return [
      elements, elements.findIndex(e => e === document.activeElement)
    ];
  }

  get modalId() {
    return this.data.get('modal-id');
  }

  open() {
    this.opened = true;

    document.body.classList.add('overflow-y-hidden');
    this.boxTarget.classList.remove('hidden');

    this.dispatch('opened', { modalId: this.modalId });
  }

  close(ev) {
    if (!this.opened)
      return;

    if (ev && ev.preventDefault)
      ev.preventDefault();

    delete this.opened;

    document.body.classList.remove('overflow-y-hidden');
    this.boxTarget.classList.add('hidden');

    this.dispatch('closed', { modalId: this.modalId });
  }

  clickOutside() {
    this.close();
  }

  onNextFocusItem(ev) {
    if (this.opened) {
      const [elements, index] = this.focusableElementsAndIndex;

      ev.preventDefault();

      if (index < 0 || index === elements.length - 1) elements[0].focus();
      else elements[index + 1].focus();
    }
  }

  onPreviousFocusItem(ev) {
    if (this.opened) {
      const [elements, index] = this.focusableElementsAndIndex;

      ev.preventDefault();

      if (index === 0) elements[elements.length - 1].focus();
      else elements[index - 1].focus();
    }
  }

  onEscape(ev) {
    if (this.opened) {
      ev.preventDefault();

      this.close();
    }
  }
}
